/**
 * @generated SignedSource<<7387693520c28e2475048a882b026aae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RemoveGroupPostInput = {
  clientMutationId?: string | null | undefined;
  groupId: string;
  postId: string;
};
export type RemoveGroupPostMutation$variables = {
  input: RemoveGroupPostInput;
};
export type RemoveGroupPostMutation$data = {
  readonly removeGroupPost: {
    readonly clientMutationId: string | null | undefined;
    readonly removedGroupPostId: string;
  } | null | undefined;
};
export type RemoveGroupPostMutation = {
  response: RemoveGroupPostMutation$data;
  variables: RemoveGroupPostMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RemoveGroupPostPayload",
    "kind": "LinkedField",
    "name": "removeGroupPost",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "removedGroupPostId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RemoveGroupPostMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RemoveGroupPostMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ae62b4afe1400dc0d2f0654a52293ecb",
    "id": null,
    "metadata": {},
    "name": "RemoveGroupPostMutation",
    "operationKind": "mutation",
    "text": "mutation RemoveGroupPostMutation(\n  $input: RemoveGroupPostInput!\n) {\n  removeGroupPost(input: $input) {\n    clientMutationId\n    removedGroupPostId\n  }\n}\n"
  }
};
})();

(node as any).hash = "fb11a2260714d4cb2267f60976c99d05";

export default node;
